import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-vip-crown-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl tracking-tight text-background-50">皇冠体育</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              业内领先的专业体育竞猜平台，覆盖足球、篮球、网球等全球顶级赛事。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 text-base mb-4">{t('footer.links')}</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('nav.home')}</Link>
              <Link to="/category/football" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">足球竞猜</Link>
              <Link to="/category/basketball" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">篮球竞猜</Link>
              <Link to="/category/tennis" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">网球竞猜</Link>
              <Link to="/category/esports" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">电竞竞猜</Link>
              <Link to="/articles" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">体育资讯</Link>
            </div>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 text-base mb-4">{t('footer.support')}</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('footer.about')}</Link>
              <a href="#" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('footer.privacy')}</a>
              <a href="#" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('footer.terms')}</a>
              <a href="#" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">{t('footer.responsible')}</a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 text-base mb-4">{t('about.contact_title')}</h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-400">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>service@huangguan-sports.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-6666</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                <span>7×24小时全天候服务</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-5 max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">{t('footer.copyright')}</p>
          <p className="text-foreground-600 text-xs">{t('footer.disclaimer')}</p>
        </div>
      </div>
    </footer>
  );
}